import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarCard } from "@perxis-auto/ui-kit/lib/components/CarCard";
const CardImage = memo(function CardImage2({
  title,
  images,
  videos,
  isLoading = false,
  ...props
}) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(CarCard.ImageSkeleton, {});
  }
  if (!images.length) {
    return /* @__PURE__ */ jsx(CarCard.Image, { images: [{ title }], ...props });
  }
  return /* @__PURE__ */ jsx(CarCard.Image, { showNav: true, images, videos, ...props });
});
export {
  CardImage
};
